import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/me3.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              {/* I fell in love with programming and I have at least learnt
              something, I think… 🤷‍♂️ */}
              Hello and welcome to my portfolio website! I'm a motivated and eager front-end developer with a passion for creating engaging, user-friendly websites. I've just started my career and I'm excited to take on new challenges and learn from experienced developers.

              <br />
              <br />With this portfolio, I hope to showcase my skills and highlight some of my recent projects. I have a strong understanding of HTML, CSS, and JavaScript, and I'm proficient in creating responsive designs that adapt to different screen sizes and devices.
              {/* <i>
                <b className="purple">  front-end developer with expertise in HTML, CSS, JavaScript, and various frameworks and tools, and a strong focus on creating user-friendly web experiences </b>
              </i> */}
              <br />
              <br />
              I'm a quick learner and always eager to expand my skillset. I'm confident that my passion for front-end development, combined with my strong work ethic, will make me a valuable addition to any team.
              {/* <i>
                <b className="purple">Web Technologies and Products </b> and
                also in areas related to{" "}
                <b className="purple">
                  Deep Learning and Natural Launguage Processing.
                </b>
              </i> */}
              <br />
              <br />If you're looking for a driven and hardworking front-end developer, I'd love to hear from you. Please take a moment to browse through my portfolio and see what I can offer. Thank you for visiting my website! 
              {/* Whenever possible, I also apply my passion for developing products
              with <b className="purple">Node.js</b> and */}
              {/* <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i> */}
              {/* &nbsp; like
              <i>
                <b className="purple"> React.js and Next.js</b>
              </i> */}
            </p>
          </Col>
          <Col md={3} className="myAvtar">
            <Tilt>
              <img src={myImg} border-radius="50%" className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/PraveenNanda124"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/NPK206701"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/praveennanda"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/praveen_npk24"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
